const swipers = document.querySelectorAll(".slider-container");
window.tabSlider = () => {
swipers.forEach((swiper) => {
  const data = swiper.querySelector(`.swiper-data-handler`);
  const mySwiper = data.dataset.class;
  const pagination = data.dataset.pagination;
  const bullets = data.dataset.bullets;
  const buttons = data.dataset.buttons;
  const autoplay = data.dataset.autoplay;
  const disableOnInteraction = data.dataset.disable;
  const colsDesktop = Number(data.dataset.colDesktop);
  const colsMobile = Number(data.dataset.colMobile);
  const colsTablet = Number(data.dataset.colTablet);
  const delay = Number(data.dataset.delay) * 1000;
  const speed = Number(data.dataset.speed);

  let myPagination = document.querySelector(
    `.swiper-pagination[data-target="${mySwiper}"]`
  );

  const paginationObj = {
    el: myPagination,
    clickable: true,
  };

  let mySwiperNext = document.querySelector(`.swiper-button-next[data-target="${mySwiper}"]`)
	let mySwiperPrev = document.querySelector(`.swiper-button-prev[data-target="${mySwiper}"]`)

  const navigationObj = {
    nextEl: mySwiperNext,
    prevEl: mySwiperPrev,
  };

  let disableOn = false;
  if (disableOnInteraction === "true") disableOn = true;

  const autoplayObj = {
    delay: delay,
    disableOnInteraction: disableOn,
    pauseOnMouseEnter: true,
  };

  const swiperObj = {
    spaceBetween: 32,
    speed: speed,
    watchSlidesProgress: false,
    loop: true,
    keyboard: {
      enabled: true,
    },
    breakpoints: {
      0: {
        slidesPerView: colsMobile,
        spaceBetween: 10,
      },
      768: {
        slidesPerView: colsTablet,
        spaceBetween: 38,
      },
      1180: {
        slidesPerView: colsDesktop,
        spaceBetween: 38,
      },
    },
  };

  if (pagination === "true") {
    swiperObj.pagination = paginationObj;
  }

  if (buttons === "true") {
    swiperObj.navigation = navigationObj;
  }

  if (autoplay === "true") {
    swiperObj.autoplay = autoplayObj;
  }

  new Swiper(`.${mySwiper}`, swiperObj);
});

}

tabSlider();